import { Controller } from '@hotwired/stimulus'

export default class TriggerActualityTabController extends Controller {
  show() {
    document.getElementById('actualities-tab')?.click();
  }
}
